module.exports = __webpack_public_path__ + "static/media/Texture.c40cb5f6.gif";